<template>
  <div style="margin: 0.8rem">
    <swipe
      class="my-swipe"
      :autoplay="3000"
      :height="200"
      :show-indicators="false"
    >
      <swipe-item
        v-for="(v, i) in bn"
        :key="i"
        @click="toDetail(v)"
        style="position: relative"
      >
        <img v-if="v.imgmax" :src="v.imgmax" class="bn-img" />
        <div class="topic">{{ v.topic }}</div>
        <!-- <div class="date"></div>
        <div class="date-text" style="opacity: 1"></div> -->
      </swipe-item>
    </swipe>
    <home-list />
    <home-call
      v-for="(v, i) in callList"
      :key="i"
      :tilde="v.topic"
      :sub-tilde="v.briefIntroduction"
      :img="v.imgmin"
      :post-date="v.postDate"
      @click="toDetail(v)"
    />
    <my-btn :value="showPage ? '加载更多' : '没有更多'" @click="evenMore" />
	<a href="http://beian.miit.gov.cn" target="_blank" class="bottom_tips">辽ICP备2023000447号-1</a>
  </div>
</template>
<script>
import { Swipe, SwipeItem } from "vant";
import homeCall from "../../common/homeCall";
import homeList from "../../common/homeList";
import myBtn from "../../common/myBtn";
import service from "../../api/service";

export default {
  name: "home",
  components: {
    Swipe,
    SwipeItem,
    homeCall,
    homeList,
    myBtn,
  },
  data() {
    return {
      baseURLB: service.baseURLB,
      bn: [], //轮播图
      callList: [], //推荐内容
      pageIndex: 1,
      showPage: true,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    //进入详情页
    toDetail(row) {
      sessionStorage.setItem("row", JSON.stringify(row));
      this.$router.push({
        path: "/xwDetail",
        query: { sourcePath: "/home", contentId: row.contentid },
      });
    },
    //初始化
    init() {
      service
        .get("/api/xw/recommended", {
          page: this.pageIndex,
          size: 7,
        })
        .then((res) => {
          if (res.status === 200) {
            if (res.data.length === 0) {
              this.showPage = false;
            }
            this.callList = this.callList.concat(res.data);
          }
        });
      service.get("/api/xw/carousel").then((res) => {
        if (res.status === 200) {
          this.bn = res.data;
        }
      });
    },
    //更多
    evenMore() {
      this.pageIndex += 1;
      this.init();
    },
  },
};
</script>
<style scoped>
.bn-img {
  height: 100%;
  width: 100%;
}

.topic {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 30px;
  background-color: rgba(177, 177, 177, 0.5);
  color: #ffffff;
  line-height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 5px;
  box-sizing: border-box;
}

.date {
  height: 30px;
  width: 100%;
  position: absolute;
  bottom: 0;
  background-color: #b1b1b1;
  opacity: 0.5;
  filter: alpha(opacity: 80);
}

.date-text {
  height: 30px;
  width: 15rem;
  position: absolute;
  bottom: 0;
  color: #ffffff;
  display: flex;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 20px;
  font-weight: lighter;
}

.bottom_tips {
	color: #666;
	display: block;
	text-align: center;
	margin: 1rem 3rem 4rem;
	margin-top: -3em;
}
</style>